<template>
  <generic-modal
    :title="$t('inventory closing')"
    icon="box alternate"
    image="/images/icons/details.png"
    v-on:destroy="destroy"
    v-bind:on_finished="this.finished"
    ref="modal_element"
  >
    <div class="description">
      <div class="ui form" ref="form">
        <div class="field">
          <label for>{{ $t("closing date") }}</label>
          <div class="ui calendar" ref="calendar">
            <div class="ui input left icon">
              <i class="calendar icon"></i>
              <input type="text" name="date" :placeholder="$t('date')" />
            </div>
          </div>
        </div>
        <div class="field">
          <label for>{{ $t("comment") }}</label>
          <textarea name="comment" rows="2" v-model="comment"></textarea>
        </div>
        <div class="ui error message"></div>
      </div>
    </div>
  </generic-modal>
</template>

<script>
import { local_api } from "@/utils";
import filters from "@/filters";
import GenericModal from "@/components/GenericModal";

export default {
  name: "InventoryOverviewClosingModal",
  filters: filters,
  components: {
    GenericModal
  },
  computed: {},
  data() {
    return {
      form: undefined,
      closing_date: "",
      comment: ""
    };
  },
  methods: {
    finished() {
      let vm = this;
      return new Promise(function(resolve, reject) {
        let isValid = vm.form.form("validate form");
        console.log(isValid);
        if (!isValid) {
          reject();
        } else {
          local_api(vm, "post", "/inventory_overview/do-close", {
            c: vm.comment,
            d: vm.closing_date
          })
            .then(() => {
              location.reload();
              resolve();
            })
            .catch(err => {
              reject(err);
            });
        }
      });
    },
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    }
  },
  mounted() {
    let vm = this;
    window.jQuery(vm.$refs.calendar).calendar({
      type: "date",
      today: true,
      onChange(date) {
        vm.closing_date = date;
      }
    });

    vm.form = window.jQuery(vm.$refs.form).form({
      fields: {
        date: ["empty"]
      }
    });
  },
  created() {},
  watch: {},
  updated: function() {}
};
</script>
